// extracted by mini-css-extract-plugin
module.exports = {"container":"Tk-z","disabled":"Uk-z","remove":"Vk-z"};